import React, { useEffect, useState } from 'react';
import reviews from "../../assets/reviews.png";
import close from '../../assets/close.svg';

const Reviews = React.memo(({ simObj, setSimObj, updateReadStatus, closePopups, getMonth, replaceVariables, popupLeft, addSpaceAfterDot }) => {
  const noOfRatings = [1, 2, 3, 4, 5];
  const ifIsRatingDoseNotExit = () => {
    for (let i = 0; i < noOfRatings.length; i++) {
      if (simObj.artifacts?.filter((data) => data.md == "REVIEWS" && data.val.metaData.starRating == noOfRatings[i]).length <= 0) {
        setSimObj((simObj) => ({
          ...simObj,
          artifacts: [...simObj.artifacts.filter((obj, index, self) =>
            index === self.findIndex((o) => o.aii === obj.aii)), {
              "artifactid_id": Date.now().toString(36).toUpperCase() + i,
              "artifactid": "QM-D-" + Date.now().toString(36).toUpperCase() + i, "readstatus": 1, "createdrampvalue": 1, "stateday": 1, "statemonth": 1, "resourcetype": "D", "metadata": "REVIEWS", "currentid": "",
              "value": {"simulationname": "QM", "id": "QM-D-" + Date.now().toString(36).toUpperCase(), "trigger": "", "type": "REVIEWS", "classification": "DISTRACTOR", "artifactName": "",
              "metaData": { "starRating": noOfRatings[i] }, "value": "", "description": "", "sender": "", "contentType": "HTML"
            }
          }].filter((obj, index, self) =>index === self.findIndex((o) => o.aii === obj.aii))
        }))
      }
    }
  }
  useEffect(() => {
    ifIsRatingDoseNotExit();
    window.jQuery('.item').tab();
    if (document.querySelectorAll(".review-box .ui.list .tab-item.active").length > 1) {
      document.querySelectorAll(".review-box .ui.list .tab-item.active").forEach((element, index) => {
        if (index != 0) {
          element.classList.remove("active");
        }
      })
    }
    if (document.querySelector(".review-box .ui.list .tab-item.active")) {
      document.querySelector(".review-box .ui.list .tab-item.active").click();
    }
  }, []);
  useEffect(() => {
    window.jQuery('.item').tab();
  }, [simObj])

  useEffect(() => {
    const ua = navigator.userAgent;
    // Detect iOS devices (including iPadOS that reports as Mac)
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // Detect Android tablets (Android but not phones)
    const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);
    
    if (isIOS || isAndroidTablet) {
      const popupBox = document.querySelector(
        '.ui.raised.popup-box'
      );

      if (popupBox) {
        popupBox.setAttribute('tabindex', '-1'); // 👈 make it focusable
      } 

      const dialog = document.querySelector('.review-box .popup-box[role="dialog"]');
      setTimeout(() => {
        if (dialog) {
          dialog.focus();
        }
      }, 1000);
    }
  }, []);
  // useEffect(() => {
  //   document.querySelector(".popup-container .header-box h2").tabIndex = -1;
  //   document.querySelector(".popup-container .header-box h2").focus();
  // }, [])
  return (
    <div className='ui pointing label popup-container review-box' style={{ "--left": `${popupLeft}px` }}>
      <div className="ui raised very padded text container segment popup-box" role="dialog" aria-modal="true" aria-labelledBy="reviewsModal">
        <div className="header-box">
          <div>
            <img className="image review icon" src={reviews} alt="" />
            <h2 id="reviewsModal" className="title" tabIndex={-1}>REVIEWS</h2>
          </div>
          <div className='close-popup' onClick={closePopups}>
            <a role="button" href="#" aria-label='Close'><img src={close} alt="" /></a>
          </div>

        </div>
        <div className="section">
          {
            simObj.artifacts?.filter((data) => data.md == "REVIEWS").length > 0 ?
              (<div className="ui stackable two column grid">
                <div className="six wide column">
                  <div className="ui secondary segment">
                    <ul className="ui divided list" role="tablist" aria-label="Reviews tabs">
                      {simObj.artifacts?.filter((data) => data.md == "REVIEWS").sort((a, b) => (b.cr - a.cr))?.filter((data, index, array) => (array.findIndex(item => item.val.metaData.starRating === data.val.metaData.starRating) === index)).sort((a, b) => ((b.aii < a.aii) ? -1 : 1)).sort((a, b) => (b.cr - a.cr)).sort((a, b) => (a.val.metaData.starRating - b.val.metaData.starRating)).map((data, index) => (
                        <li id={data.aii} key={data.aii} className={`item tab-item ${(index == 0) || (data.ci == data.aii) ? 'active' : ''} ${data.rs == 1 ? 'visited' : ''}`} data-tab={"tab-" + data.aii} role='tab' onKeyDown={(e) => e.key == "Enter" && e.currentTarget.click()} tabIndex={index == 0 ? 0 : -1} aria-selected={index == 0} aria-controls={`tab_${data.aii}_tab`}>
                          <div className="content">
                            <span className="sr-only">{data.val.metaData.starRating} Star rating</span>
                            <ul className="star-list" aria-hidden={true}>
                              {
                                noOfRatings.map((number, index) => (
                                  ((number) <= data.val.metaData.starRating) ? (<li key={number}><span className="rating fa fa-star checked" /></li>) : (<li key={number}><span className="rating fa fa-star-o" /></li>)
                                ))
                              }
                            </ul>
                            {
                              (simObj.artifacts?.filter((rdata) => (rdata.md == "REVIEWS" && rdata.rs == 0) && (rdata.val.metaData.starRating == data.val.metaData.starRating)).length > 0) && <span className="rating-count right floated" rating-count={simObj.artifacts?.filter((rdata) => (rdata.md == "REVIEWS" && rdata.rs == 0) && (rdata.val.metaData.starRating == data.val.metaData.starRating)).length}><span className="sr-only">unselected</span></span>
                            }
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="ten wide column" tabIndex={-1}>
                  <div>
                    {simObj.artifacts?.filter((data) => data.md == "REVIEWS").sort((a, b) => (b.cr - a.cr))?.filter((data, index, array) => (array.findIndex(item => item.val.metaData.starRating === data.val.metaData.starRating) === index)).sort((a, b) => ((b.aii < a.aii) ? -1 : 1)).sort((a, b) => (b.cr - a.cr)).sort((a, b) => (a.val.metaData.starRating - b.val.metaData.starRating)).map((data, index) => (
                      <div className={`ui tab review-container ${index == 0 ? "active" : ""}`} key={data.aii} data-tab={"tab-" + data.aii} id={`tab_${data.aii}_tab`} role="tabpanel" aria-labelledby={data.aii} hidden>
                        {
                          simObj.artifacts?.filter((data) => data.md == "REVIEWS")?.filter((artifact, index) => artifact.val.metaData.starRating == data.val.metaData.starRating).sort((a, b) => ((b.sm < a.sm) ? -1 : 1)).sort((a, b) => ((b.sm == a.sm && b.sd < a.sd) ? -1 : 1)) ?
                            simObj.artifacts?.filter((data) => data.md == "REVIEWS")?.filter((artifact, index) => artifact.val.metaData.starRating == data.val.metaData.starRating).sort((a, b) => ((b.sm < a.sm) ? -1 : 1)).sort((a, b) => ((b.sm == a.sm && b.sd < a.sd) ? -1 : 1)).map((artifObj, index) => (
                              artifObj.val?.value.length != 0 ?
                                (<div className="review-item" key={artifObj.aii}>
                                  <div artifact_id={data.aii} className={`ui compact message ${artifObj.rs == 1 ? 'visited' : ''}`} id={artifObj.aii} tabIndex={0} onClick={updateReadStatus} onKeyUp={updateReadStatus} >
                                    <span className="sr-only" aria-live="assertive">{artifObj.rs == 1 ? 'Message read' : 'Message unread'}</span>
                                    <h3>{artifObj.val.sender}</h3>
                                    <span className="sr-only">{data.val.metaData.starRating} Star rating</span>
                                    <span className='right floated'>
                                      <ul className="star-list">
                                        {
                                          noOfRatings.map((number, index) => (
                                            ((number) <= data.val.metaData.starRating) ? (<li key={number}><span className="rating fa fa-star checked" /></li>) : (<li key={number}><span className="rating fa fa-star-o" /></li>)
                                          ))
                                        }
                                      </ul>
                                    </span>
                                    <p dangerouslySetInnerHTML={{ __html: replaceVariables(addSpaceAfterDot(artifObj.val.value)) }}></p>
                                    <span className='right floated'>{getMonth(artifObj.sm)} {artifObj.sd}</span>
                                  </div>
                                </div>)
                                :
                                (<div className='empty-message'>
                                  <div>
                                    There are no reviews for this category.
                                  </div>
                                </div>)
                            ))
                            :
                            <div className='empty-message'>
                              <div>
                                There are no reviews for this category.
                              </div>
                            </div>
                        }
                      </div>
                    ))}
                  </div>
                </div>
              </div>)
              :
              (<div className='empty ui stackable grid'>
                <div className="column">
                  <div className="ui info message">
                    <div className="header">
                      There are no reviews for this category.
                    </div>
                  </div>
                </div>
              </div>)
          }

        </div>
      </div>
    </div>
  )
})

export default Reviews